/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Validation { 
    message?: string;
    name?: string;
    validator?: Validation.ValidatorEnum;
    validatorOption?: any;
}
export namespace Validation {
    export type ValidatorEnum = 'REQUIRED' | 'REQUIRED_TRUE' | 'MIN' | 'MAX' | 'EMAIL' | 'MIN_LENGTH' | 'MAX_LENGTH' | 'PATTERN' | 'REQUIRED_AT_LEAST_X';
    export const ValidatorEnum = {
        REQUIRED: 'REQUIRED' as ValidatorEnum,
        REQUIREDTRUE: 'REQUIRED_TRUE' as ValidatorEnum,
        MIN: 'MIN' as ValidatorEnum,
        MAX: 'MAX' as ValidatorEnum,
        EMAIL: 'EMAIL' as ValidatorEnum,
        MINLENGTH: 'MIN_LENGTH' as ValidatorEnum,
        MAXLENGTH: 'MAX_LENGTH' as ValidatorEnum,
        PATTERN: 'PATTERN' as ValidatorEnum,
        REQUIREDATLEASTX: 'REQUIRED_AT_LEAST_X' as ValidatorEnum
    };
}
